import { BaseService } from './base-service';
import type {
	CreateErgonomicWorkAnalysisActionPlanRequestDTO,
	CreateErgonomicWorkAnalysisActionPlanResponseDTO,
	UpdateErgonomicWorkAnalysisActionPlanRequestDTO,
	UpdateErgonomicWorkAnalysisActionPlanResponseDTO,
	CreateErgonomicWorkAnalysisActionPlanTaskRequestDTO,
	CreateErgonomicWorkAnalysisActionPlanTaskResponseDTO,
	DeleteErgonomicWorkAnalysisActionPlanTaskRequestDTO,
	DeleteErgonomicWorkAnalysisActionPlanTaskResponseDTO
} from '@/core/dto/ergonomic-work-analisys';

const ACTION_PLAN_URL = '/action_plan/v2';

export class ErgonomicWorkAnalysisActionPlanService extends BaseService<any> {
	private static instance: ErgonomicWorkAnalysisActionPlanService;

	private constructor() {
		super();
	}

	public static getInstance(): ErgonomicWorkAnalysisActionPlanService {
		if (!ErgonomicWorkAnalysisActionPlanService.instance) {
			ErgonomicWorkAnalysisActionPlanService.instance = new ErgonomicWorkAnalysisActionPlanService();
		}
		return ErgonomicWorkAnalysisActionPlanService.instance;
	}

	public async create(
		params: CreateErgonomicWorkAnalysisActionPlanRequestDTO
	): Promise<CreateErgonomicWorkAnalysisActionPlanResponseDTO> {
		const url = `${ACTION_PLAN_URL}/report`;
		const { data } = await this.getInstance().post<CreateErgonomicWorkAnalysisActionPlanResponseDTO>(url, params);
		return data;
	}

	public async update(
		params: UpdateErgonomicWorkAnalysisActionPlanRequestDTO
	): Promise<UpdateErgonomicWorkAnalysisActionPlanResponseDTO> {
		const url = `${ACTION_PLAN_URL}/${params.action_plan_id}`;
		const { data } = await this.getInstance().put<UpdateErgonomicWorkAnalysisActionPlanResponseDTO>(url, params);
		return data;
	}

	public async createTask(
		params: CreateErgonomicWorkAnalysisActionPlanTaskRequestDTO
	): Promise<CreateErgonomicWorkAnalysisActionPlanTaskResponseDTO> {
		const url = `${ACTION_PLAN_URL}/task`;
		const { data } = await this.getInstance().post<CreateErgonomicWorkAnalysisActionPlanTaskResponseDTO>(
			url,
			params
		);
		return data;
	}

	public async deleteTask(
		params: DeleteErgonomicWorkAnalysisActionPlanTaskRequestDTO
	): Promise<DeleteErgonomicWorkAnalysisActionPlanTaskResponseDTO> {
		const url = `${ACTION_PLAN_URL}/task`;
		const { data } = await this.getInstance().delete<DeleteErgonomicWorkAnalysisActionPlanTaskResponseDTO>(url, {
			params
		});
		return data;
	}
}
